<template>
    <div class="text-center">
      <v-dialog persistent v-model="visible" width="800">
        <v-card class="not-margin pt-0 pr-0 pl-0">
          <v-toolbar dark color="primary">
            <div class="text-center">
              <v-icon>mdi-pencil</v-icon>
              {{ edit ? "Editar" : "Cadastrar" }} Usuário
            </div>
          </v-toolbar>
          <div class="container dialog">
            <v-form ref="form" v-if="visible">
              <v-row class="d-flex justify-center mt-7">
                <v-col :cols="edit ? 12 : 8">
                  <v-text-field
                    v-model="content.nomeCompleto"
                    label="Nome do Usuário*"
                    outlined
                    maxlength="80"
                    counter="80"
                    :readonly="edit"
                    dense
                    :rules="[$required]"
                  ></v-text-field>
                </v-col>
                <v-col cols="4" class="d-flex align-center margin-top-negative" v-if="!edit">
                  <v-checkbox
                      v-model="form.dados.inserirNomeSocial"
                      dense
                  >
                      <template v-slot:label>
                          Inserir Nome Social
                          <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                  <v-icon right v-bind="attrs" v-on="on" @click.stop>mdi-chat-question-outline</v-icon>
                              </template>
                              <span class="custom-tooltip">
                                  Nome social é a designação pela qual a pessoa travesti ou transexual se identifica<br>
                                  e é socialmente reconhecida e DEVERÁ SER COMPOSTO POR PRENOME, ACRESCIDO DO(S) <br>
                                  ACRESCIDO DO(S) SOBRENOME(S) FAMILIAR(ES) CONSTANTE(S) DO NOME CIVIL, não podendo ser irreverente<br>
                                  ou atentar contra o pudor.
                              </span>
                          </v-tooltip>
                      </template>
                  </v-checkbox>
                </v-col>
              </v-row>
              <v-row class="d-flex justify-center mt-3" >
                  <v-col cols="12" v-if="form.dados.inserirNomeSocial && !edit">
                    <v-text-field
                        label="Nome Social"
                        v-model="content.nomeSocial"
                        outlined
                        maxlength="80"
                        counter="80"
                        dense
                        :rules="[$required]"
                    />
                  </v-col>
                </v-row>
                <v-row class="d-flex justify-center mt-7">
                  <v-col cols="6">
                    <v-text-field
                      v-model="content.cpf"
                      label="CPF*"
                      v-mask="'###.###.###-##'"
                      outlined
                      dense
                      maxlength="14"
                      counter="14"
                      :rules="[[$required], (v) => $validarCpf(v)]"
                      :readonly="edit"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                  <v-text-field
                    v-model="content.email"
                    label="E-mail*"
                    outlined
                    dense
                    maxlength="120"
                    counter="120"
                    :rules="[[$required], (v) => $email(v)]"
                    :readonly="edit"
                  ></v-text-field>
                  </v-col>
                </v-row>
                <v-row v-if="edit" class="d-flex justify-center mt-7">
                  <v-col cols="12">
                    <v-select
                      v-model="content.perfis"
                      :items="form.lists.listPerfis"
                      :item-text="'nome'"
                      :item-value="'id'"
                      :rules="edit ? [(p) => p && p.length > 0 || 'Campo obrigatório'] : []"
                      label="Perfil*"
                      multiple
                      outlined
                      dense
                      return-object
                    ></v-select>
                  </v-col>
              </v-row>
            </v-form>
          </div>
          <sigfoco-buttons
            @click="salvar()"
            @cancel="fechar"
            :actionText="edit ? 'Salvar' : 'Salvar'"
          ></sigfoco-buttons>
        </v-card>
      </v-dialog>
    </div>
  </template>
  
  <script>
  import { DialogProps } from '~/commons/classes/dialog-props';
  import { Usuario } from '~/commons/classes/usuario';
  import PerfilService from '~/services/manter-perfil.service';
  import UsuarioService from '~/services/manter-usuario.service';
  export default {
    props: new DialogProps(Usuario),
    mixins: [UsuarioService, PerfilService],
    data: () => ({
      form: {
        lists: {
          listPerfis: [],
        },
        dados: {
          inserirNomeSocial: false,
        },
      }
    }),
    methods: {
      fechar() {
        this.form.dados.inserirNomeSocial = false;
        this.$emit('onClose');
      },
      salvar() { 
        const save = () => {
          return this.$swal({
            text: `Deseja confirmar essa operação?`,
            type: "warning",
            showCancelButton: true,
            confirmButtonText: `Confirmar`,
            cancelButtonText: `Cancelar`,
          }).then(() => {
            const cpf = this.$unMask(this.content.cpf);
            const payloadEdit = {
              ...this.content,
              cpf,
              perfis: this.content.perfis.map((p) => 
                typeof p === 'object' ? p.id : p
              ),
            };       
            return this.edit
            ? this.$editarUsuario(payloadEdit, this.content.id)
            : this.$cadastrarUsuario(payloadEdit);              
          });
        };
        if (this.$validarFormulario()) {
          if (this.edit && (!this.content.perfis || this.content.perfis.length === 0)) {
            this.$notifyWarning("Informe um ou mais perfis associados.");
          } else {
            save().then(({ data }) => {
              this.$notifySuccess(data.mensagem);
              this.$emit("onClose");
              this.$emit("onSave");
              this.form.dados.inserirNomeSocial = false;
            });
          }
        }
      },
    },
    watch: {
      'form.dados.inserirNomeSocial'(newValue) {
          if (!newValue) {
              this.content.nomeSocial = null;
          }
      },
    },
    mounted() {
      this.$buscarPerfis({ params: { situacao: true } }).then(({ data }) => {
        this.form.lists.listPerfis = data.lista;
      });
    }
  };
  </script>
  